import React, { useState, useEffect } from 'react';
import api from '../api';

const ACTION_LABEL = {
  login: '🔐 Logowanie', create_procedure: '📝 Nowa procedura', update_procedure: '✏️ Edycja procedury',
  publish_procedure: '✅ Publikacja', archive_procedure: '📦 Archiwizacja', delete_procedure: '🗑️ Usunięcie procedury',
  view_procedure: '👁️ Podgląd', add_comment: '💬 Komentarz', upload_attachment: '📎 Załącznik',
  delete_attachment: '🗑️ Usunięcie załącznika', create_department: '🏢 Nowy dział', create_user: '👤 Nowy użytkownik',
  restore_version: '🔄 Przywrócenie wersji',
};

export default function ActivityPage() {
  const [stats, setStats] = useState(null);
  const [logs, setLogs] = useState([]);
  const [tab, setTab] = useState('stats');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get('/activity/stats').then(r => setStats(r.data)), api.get('/activity?limit=50').then(r => setLogs(r.data))]).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 32, color: 'var(--gray-400)' }}>Ładowanie...</div>;

  return (
    <div>
      <h1 className="page-title">Aktywność i statystyki</h1>
      <div style={{ display: 'flex', gap: 0, borderBottom: '1px solid var(--gray-200)', marginBottom: 24 }}>
        {[{ key: 'stats', label: 'Statystyki' }, { key: 'logs', label: 'Logi aktywności' }].map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{ padding: '8px 20px', border: 'none', background: 'none', cursor: 'pointer', borderBottom: tab === t.key ? '2px solid var(--primary)' : '2px solid transparent', color: tab === t.key ? 'var(--primary)' : 'var(--gray-500)', fontWeight: tab === t.key ? 500 : 400, fontSize: 13.5, marginBottom: -1 }}>{t.label}</button>
        ))}
      </div>
      {tab === 'stats' && stats && (
        <div>
          <div className="stats-grid">
            <div className="stat-card"><div className="stat-value">{stats.procedures.total}</div><div className="stat-label">Procedur łącznie</div></div>
            <div className="stat-card"><div className="stat-value" style={{ color: 'var(--success)' }}>{stats.procedures.published}</div><div className="stat-label">Opublikowanych</div></div>
            <div className="stat-card"><div className="stat-value" style={{ color: 'var(--warning)' }}>{stats.procedures.draft}</div><div className="stat-label">Szkiców</div></div>
            <div className="stat-card"><div className="stat-value">{stats.procedures.archived}</div><div className="stat-label">Archiwalnych</div></div>
            <div className="stat-card"><div className="stat-value">{stats.users}</div><div className="stat-label">Użytkowników</div></div>
            <div className="stat-card"><div className="stat-value">{stats.departments}</div><div className="stat-label">Działów</div></div>
            <div className="stat-card"><div className="stat-value">{stats.comments}</div><div className="stat-label">Komentarzy</div></div>
            <div className="stat-card"><div className="stat-value">{stats.attachments}</div><div className="stat-label">Załączników</div></div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div className="card">
              <div className="card-title" style={{ marginBottom: 12 }}>🔥 Najczęściej przeglądane</div>
              {stats.topProcedures.length === 0 ? <p style={{ color: 'var(--gray-400)', fontSize: 13 }}>Brak danych</p> : stats.topProcedures.map((p, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', borderBottom: '1px solid var(--gray-100)' }}>
                  <span style={{ width: 20, height: 20, borderRadius: '50%', background: 'var(--primary-light)', color: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700 }}>{i + 1}</span>
                  <span style={{ flex: 1, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.title}</span>
                  <span style={{ fontSize: 12, color: 'var(--gray-400)' }}>{p.views}×</span>
                </div>
              ))}
            </div>
            <div className="card">
              <div className="card-title" style={{ marginBottom: 12 }}>🕐 Ostatnie logowania</div>
              {stats.recentLogins.length === 0 ? <p style={{ color: 'var(--gray-400)', fontSize: 13 }}>Brak danych</p> : stats.recentLogins.map((l, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', borderBottom: '1px solid var(--gray-100)', fontSize: 13 }}><span>{l.name}</span><span style={{ color: 'var(--gray-400)', fontSize: 12 }}>{new Date(l.created_at).toLocaleString('pl-PL')}</span></div>
              ))}
            </div>
          </div>
        </div>
      )}
      {tab === 'logs' && (
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <table>
            <thead><tr><th>Czas</th><th>Użytkownik</th><th>Akcja</th><th>Szczegóły</th></tr></thead>
            <tbody>
              {logs.map(l => (
                <tr key={l.id}>
                  <td style={{ color: 'var(--gray-400)', fontSize: 12.5, whiteSpace: 'nowrap' }}>{new Date(l.created_at).toLocaleString('pl-PL')}</td>
                  <td style={{ fontWeight: 500 }}>{l.user_name || '—'}</td>
                  <td>{ACTION_LABEL[l.action] || l.action}</td>
                  <td style={{ color: 'var(--gray-400)', fontSize: 12.5 }}>{l.details ? (JSON.parse(l.details)?.title || JSON.parse(l.details)?.name || JSON.parse(l.details)?.filename || '') : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
